import {globalContainer} from './container.ts';

import {WebApiCacheFetcher} from './fetcher/web-api-cache-fetcher.ts';
import {NativeFetcher} from './fetcher/nativefetcher.ts';
import {CachingFetcher} from './fetcher/cachingfetcher.ts';

import {featureFlag} from './allspice_app/lib/feature-flag.ts';

const {appSubUrl} = window.config;

export function initDependencyInjection() {
  globalContainer.register('appSubUrl', () => {
    return appSubUrl;
  });
  globalContainer.register('fetcher', () => {
    if (window.caches && featureFlag('enableWebApiCacheFetcher')) {
      console.debug('Using Web API cache fetcher');
      return new WebApiCacheFetcher(new NativeFetcher());
    }
    return new CachingFetcher(new NativeFetcher());
  });
}
